/* eslint-disable prettier/prettier */
import { Box, PageLayout } from '@bharatpe/bharat-ui';
import React from 'react';
import LoaderImage from '../../../assets/images/loader-bui.gif';
import './styles.scss';
interface Props {
	primaryText: string;
	secondryText: string;
}

const style = {
	height: 200,
	witdh: 200,
};

const GenericLoader: React.FC<Props> = ({ primaryText, secondryText }) => {
	return (
		<PageLayout className="hide-overflow">
			<>
				<div className="absolute-center width-100">
					<div className="loader-content flex flex-justify-center flex-center content-center">
						<img src={LoaderImage} alt="loader" className="loader white-background" />
					</div>
					<div className="content-center">
						<p className="SemiBold600 logo-green">{primaryText}</p>
					</div>
					<div className="content-center">
						<p className="SemiBold600 logo-green">{secondryText}</p>
					</div>
				</div>
				<div style={{ position: 'absolute', top: '85%', left: '25%' }}>
					<Box className="secondary-background grey-border br1 p2">
						<p className="grey-dark">DO NOT PRESS BACK OR SWITCH APP </p>
					</Box>
				</div>
			</>
		</PageLayout>
	);
};

export default GenericLoader;
